import { useTranslation } from 'react-i18next';
import { Input, InputProps } from '../Input';
import { withTranslation } from '../../locales/hoc';

const FirstNameFieldComponent = (inputProps: InputProps) => {
	const { t } = useTranslation();

	return (
		<Input
			textContentType="givenName"
			label={t('common.first-name')}
			placeholder={t('common.first-name')}
			{...inputProps}
		/>
	);
};

export const FirstNameField = withTranslation(FirstNameFieldComponent);
